import {
  AddressType,
  AvailabilityCheckPageValueType,
  HouseholdConfigurationType,
  ResultType,
  TargetGroup, TrackingInfoType,
} from '@/types/av-check';

import {
  SET_ADDRESS,
  SET_PAGE_VALUE,
  SET_RESULT,
  SET_RESULT_ERROR,
  SET_CURRENT_TARGET_GROUP,
  SET_CURRENT_CONTRACT_DURATION,
  SET_SPECIAL_RESERVATIONS,
  SET_CITY_LIST,
  SET_STREET_LIST,
  SET_HOUSEHOLD_CONFIG,
  SET_TRACKING_INFO,
} from './action-types';

export const setAddress = (address : AddressType) => ({
  type: SET_ADDRESS,
  value: address,
});

export const setHouseholdConfig = (householdConfig: HouseholdConfigurationType) => ({
  type: SET_HOUSEHOLD_CONFIG,
  value: householdConfig,
});

export const setPageValue = (pageValue : AvailabilityCheckPageValueType) => ({
  type: SET_PAGE_VALUE,
  value: pageValue,
});

export const setResult = (result : ResultType | undefined) => ({
  type: SET_RESULT,
  value: result,
});

export const setResultError = (isError : boolean) => ({
  type: SET_RESULT_ERROR,
  value: isError,
});

export const setCurrentTargetGroup = (targetGroup: TargetGroup) => ({
  type: SET_CURRENT_TARGET_GROUP,
  value: targetGroup,
});

export const setCurrentContractDuration = (contractDuration: number) => ({
  type: SET_CURRENT_CONTRACT_DURATION,
  value: contractDuration,
});

export const setSpecialReservations = (active: boolean) => ({
  type: SET_SPECIAL_RESERVATIONS,
  value: active,
});

export const setCityList = (cities: string[] | undefined) => ({
  type: SET_CITY_LIST,
  value: cities,
});

export const setStreetList = (streets: string[] | undefined) => ({
  type: SET_STREET_LIST,
  value: streets,
});

export const setTrackingInfo = (trackingInfo:TrackingInfoType) => ({
  type: SET_TRACKING_INFO,
  value: trackingInfo,
});
